function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as types from './types';
export default function simpleValues(state = {}, action) {
  switch (action.type) {
    case types.ON_SIMPLE_VALUE_CHANGED:
      return _extends({}, state, {
        [action.id]: action.value
      });

    default:
      return state;
  }
}